import h from "ping.js";
import { defineComponent as m, ref as d, computed as C, onBeforeUnmount as w } from "vue";
/*!
* v-offline v2.4.0
* (c) 2022 Vinayak Kulkarni
* @license MIT
*/
const y = m({
  name: "VOffline",
  props: {
    onlineClass: {
      type: String,
      required: !1,
      default: ""
    },
    offlineClass: {
      type: String,
      required: !1,
      default: ""
    },
    pingUrl: {
      type: String,
      required: !1,
      default: "https://google.com"
    }
  },
  setup(n, { emit: t }) {
    const o = d(navigator.onLine || !1), f = d(["online", "offline", "load"]), a = d(n.pingUrl || "https://google.com"), u = C(() => o.value ? typeof n.onlineClass == "string" ? n.onlineClass : "" : typeof n.offlineClass == "string" ? n.offlineClass : "");
    f.value.forEach(
      (s) => window.addEventListener(s, l)
    ), w(() => {
      f.value.forEach(
        (s) => window.removeEventListener(s, l)
      );
    });
    async function l() {
      const s = new h();
      try {
        (await s.ping(a.value) || navigator.onLine) && (o.value = !0, t("detected-condition", o.value));
      } catch (e) {
        (e || !navigator.onLine) && (o.value = !1, t("detected-condition", o.value));
      }
    }
    return {
      wrapperClass: u
    };
  }
});
function O(n, t, o, f, a, u, l, s) {
  var e = typeof n == "function" ? n.options : n;
  t && (e.render = t, e.staticRenderFns = o, e._compiled = !0), f && (e.functional = !0), u && (e._scopeId = "data-v-" + u);
  var r;
  if (l ? (r = function(i) {
    i = i || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !i && typeof __VUE_SSR_CONTEXT__ < "u" && (i = __VUE_SSR_CONTEXT__), a && a.call(this, i), i && i._registeredComponents && i._registeredComponents.add(l);
  }, e._ssrRegister = r) : a && (r = s ? function() {
    a.call(
      this,
      (e.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : a), r)
    if (e.functional) {
      e._injectStyles = r;
      var v = e.render;
      e.render = function(g, _) {
        return r.call(_), v(g, _);
      };
    } else {
      var c = e.beforeCreate;
      e.beforeCreate = c ? [].concat(c, r) : [r];
    }
  return {
    exports: n,
    options: e
  };
}
var R = function() {
  var t = this, o = t._self._c;
  return t._self._setupProxy, o("div", { class: t.wrapperClass }, [t._t("default")], 2);
}, $ = [], E = /* @__PURE__ */ O(
  y,
  R,
  $,
  !1,
  null,
  null,
  null,
  null
);
const L = E.exports;
let p = !1;
const V = {
  install(n) {
    p || (n.component("VOffline", L), p = !0);
  }
};
export {
  L as VOffline,
  V as default
};
//# sourceMappingURL=v-offline.js.map
